/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Section_DocumentsInputs */

const en_section_documents = /** @type {(inputs: Section_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

const es_section_documents = /** @type {(inputs: Section_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Section_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const section_documents = /** @type {((inputs?: Section_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Section_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_section_documents(inputs)
	return es_section_documents(inputs)
});